// Какие-то штуки, которые должны работать на многих страницах.
// TODO: разнести по отдельным модулям.

import popupsState from "../popups/popups-state";
import cookies from "../cookies";
import utils from "../utils";

const $ = window.jQuery;
const { user } = window.DA;
// require("jquery.icheck");

// http://stackoverflow.com/a/5107878/2111934
$.ajaxSetup({
    cache: false,
    beforeSend(xhr, settings) {
        if (!(/^http:.*/.test(settings.url) || /^https:.*/.test(settings.url))) {
            // Only send the token to relative URLs i.e. locally.

            // контрольное число для защиты от ботов
            const challenge = utils.calcChallenge(
                cookies.get("csrftoken"),
                Math.floor(Date.now() / 1000),
            );
            xhr.setRequestHeader("X-CSRFToken", cookies.get("csrftoken"));
            xhr.setRequestHeader("X-Challenge", challenge);
        }
    },
});

function initBackLink() {
    // History back.
    $("#history-back")
        .click(event => {
            event.preventDefault();
            window.history.go(-1);
            return false;
        });
    $(".back")
        .click(e => {
            if ($(this)
                .attr("href") === "#") {
                e.preventDefault();
                window.history.back();
            }
        });
}

function styleControls() {
    // Part checkbox.
    $(":checkbox.icheckbox")
        .iCheck({ checkboxClass: "icheckbox_minimal-grey" });
    // disable tel links for desktop
    if (!/mobile/i.test(navigator.userAgent)) {
        $("a[href^='tel:']")
            .click(e => {
                e.preventDefault();
            });
    }
    // restore disabled buttons if user clicks browser's back button
    $("#structure-submit")
        .attr("disabled", false);
    initCustomSelect();
}

/**
 * Custom-looking selects on preview document, process document and manage structure templates
 */
function initCustomSelect() {
    function showSelectValue($select) {
        const str = $select.find(":selected")
            .text();
        $select.next(".out")
            .text(str);
    }
    const $selects = $(".selectdiv select");
    if ($selects.length) {
        $selects.change(function select() {
            showSelectValue($(this));
        });
        $selects.each((idx, selectEl) => {
            showSelectValue($(selectEl));
        });
    }
}

function logoutOtherUser() {
    const url = "/profile/get-user/";
    $.ajax({
        url,
        type: "get",
        cache: false,
        success(currentUser) {
            if (currentUser.id !== user.id) {
                // page is expired and needs to be refreshed.
                popupsState.dispatchOpen({
                    newPopupId: "message_popup",
                    popupData: { message: "Обновляю страницу через 2 секунды..." },
                });
                if (currentUser.id && document.location.pathname.indexOf("clean/simple") >= 0) {
                    // form contains previous user token and should not be re-submit
                    setTimeout(() => {
                        window.location = "/#demo";
                    }, 2000);
                } else {
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }
            }
        },
    });
}

$(() => {
    // Facebook api tale.
    if (window.location.hash === "#_=_") {
        window.location.hash = "";
    }

    initBackLink();
    styleControls();

    $(window)
        .on("focus", logoutOtherUser);
});

export default {};
